import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import customizeTheme from "@/components/cotumizeTheme/index";
import ProfileAvatar from "@/components/appbar/ProfileAvatar";
// import dayjs from "dayjs";
import Language from "@/components/appbar/Language";
import SubMenuItem from "@/components/appbar/SubMenuItem";
import { authMixin } from "@/mixins/authMixin";
import CustomLink from "@/components/appbar/CustomLink/index.vue";

export default {
  name: "app-bar",
  components: {
    customizeTheme,
    ProfileAvatar,
    Language,
    SubMenuItem,
    CustomLink
  },

  props: ["menus"],
  mixins: [authMixin],
  data: () => ({
    goToPublicPage: process.env.VUE_APP_PUBLIC_BASE_URL,
    menu: false,
    baseUrl: process.env.VUE_APP_BASE_URL,
    marketUrl: process.env.VUE_APP_MARKET_BASE_URL,
    items: [
      {
        title: "فارسی",
        value: "fa"
      },
      {
        title: "English",
        value: "en"
      }
    ],
    hoveredMenu: null,
    isForceClose: false
  }),
  computed: {
    ...mapGetters({
      // drawerItemName: GET_DRAWER_ITEM_NAME,
      drawerState: types.GET_DRAWER,
      notificationDrawer: types.GET_NAVIGATIONS_DRAWER,
      notifications: types.notifications.getters.GET_NOTIFICATIONS,
      verifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),
    // selectedLang() {
    //   return this.items.find(el => el.value === this.$i18n.locale).title;
    // },
    isVerify() {
      return this.verifyInfo?.is_verified;
    },

    drawerItemName() {
      return this.$route.meta.appBarTitle;
    },
    toggledDrawerState() {
      return this.drawerState;
    },
    newNotificationExist() {
      let state = false;
      if (Object.entries(this.notifications).length !== 0) {
        this.notifications.data.find(elem => {
          if (elem.read_at === null) {
            state = true;
          }
        });
      }
      return state;
    }
  },

  mounted() {
    this.setSelectedBaseCurrency(1);
    // this.switchLangFunc();
  },

  methods: {
    ...mapActions({
      drawerAction: types.ACTION_DRAWER,
      notificationDrawerAction: types.ACTION_NAVIGATIONS_DRAWER,
      setSelectedBaseCurrency: types.market.actions.SET_SELECTED_BASE_CURRENCY
    }),

    drawer() {
      this.drawerAction(!this.toggledDrawerState);
    },
    notificationDrawerFunc() {
      this.notificationDrawerAction(!this.notificationDrawer);
    },
    filterMarketList(currencyId) {
      this.setSelectedBaseCurrency(currencyId);
    },
    closeMenus() {
      for (let item of this.$refs.submenu) {
        item.isActive = false;
      }
      // console.log(this.$refs.test.deativate());
      // this.closingFlag = true
      // setTimeout(() => {this.closingFlag = false} , 1)
    },
    menuClick() {
      this.isForceClose = true;
      setTimeout(() => {
        this.isForceClose = false;
      }, 100);
      this.$emit("closeMenus");
    }
    // switchLangFunc() {
    //   if (this.$i18n.locale === "fa") {
    //     this.$vuetify.rtl = false;
    //     this.$i18n.locale = "en";
    //     localStorage.setItem("lang", this.$i18n.locale);
    //     localStorage.setItem("direction", "ltr");
    //   } else {
    //     this.$vuetify.rtl = true;
    //     this.$i18n.locale = "fa";
    //     localStorage.setItem("lang", this.$i18n.locale);
    //     localStorage.setItem("direction", "rtl");
    //   }
    //
    //   this.$router.push({
    //     query: Object.assign({}, this.$route.query, {
    //       lang: this.$i18n.locale
    //     })
    //   });
    //   dayjs.calendar("jalali").locale(this.$i18n.locale);
    // }
  }
};
